import { createSlice } from '@reduxjs/toolkit';

const crowdsaleSlice = createSlice({
  name: 'crowdsale',
  initialState: {
    contract: null,
    transaction: {
      isPending: false,
      isSuccessful: false,
      isError: false,
      hash: null
    },
    saleStatus: {
      isOpen: false,
      isPaused: false,
      whitelistEnabled: false
    },
    stats: {
      totalRaised: '0',
      totalTokensSold: '0',
      contributorCount: 0,
      whitelistCount: 0
    },
    userContribution: {
      amount: '0',
      tokensPurchased: '0',
      isWhitelisted: false
    },
    whitelistedAddresses: [],
    events: []
  },
  reducers: {
    setCrowdsaleContract: (state, action) => {
      state.contract = action.payload;
    },
    setSaleStatus: (state, action) => {
      state.saleStatus = {
        ...state.saleStatus,
        ...action.payload
      };
    },
    setCrowdsaleStats: (state, action) => {
      state.stats = {
        ...state.stats,
        ...action.payload
      };
    },
    setUserContribution: (state, action) => {
      state.userContribution = {
        ...state.userContribution,
        ...action.payload
      };
    },
    setWhitelistedAddresses: (state, action) => {
      state.whitelistedAddresses = action.payload;
    },
    setCrowdsaleTransaction: (state, action) => {
      state.transaction = {
        ...state.transaction,
        ...action.payload
      };
    },
    addCrowdsaleEvent: (state, action) => {
      state.events = [action.payload, ...state.events];
    },
    buyTokensRequest: (state) => {
      state.transaction = {
        isPending: true,
        isSuccessful: false,
        isError: false,
        hash: null
      };
    },
    buyTokensSuccess: (state, action) => {
      state.transaction = {
        isPending: false,
        isSuccessful: true,
        isError: false,
        hash: action.payload
      };
    },
    buyTokensFail: (state) => {
      state.transaction = {
        isPending: false,
        isSuccessful: false,
        isError: true,
        hash: null
      };
    }
  }
});

export const {
  setCrowdsaleContract,
  setSaleStatus,
  setCrowdsaleStats,
  setUserContribution,
  setWhitelistedAddresses,
  setCrowdsaleTransaction,
  addCrowdsaleEvent,
  buyTokensRequest,
  buyTokensSuccess,
  buyTokensFail
} = crowdsaleSlice.actions;

export default crowdsaleSlice.reducer;

